import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    continue: {
        id: 'new_cards.continue',
        defaultMessage: 'Continue',
    },
})
